<template>
    <div class="modal-overlay">
        <div class="modal-card">
            <div class="modal-header">
                <h6 class="modal-title"><i class="fa fa-pencil"></i> Update Allocation</h6>
                <button class="modal-close" @click="$emit('close')">
                    <i class="fa fa-times"></i>
                </button>
            </div>
            <div class="modal-body">
                <div class="info-row">
                    <span class="info-label">Staff</span>
                    <span class="info-val">{{ item.name }} ({{ item.serial_no }})</span>
                </div>
                <div class="info-row">
                    <span class="info-label">Referrer</span>
                    <span class="info-val">{{ item.parent_name }} {{ item.parent_serial_no ? '(' + item.parent_serial_no + ')' : '' }}</span>
                </div>
                <div class="mb-2">
                    <label class="field-label">Allocation Amount</label>
                    <input
                        v-model="amount"
                        type="number"
                        class="form-control"
                        placeholder="Enter Amount"
                    />
                </div>
            </div>
            <div class="modal-footer">
                <button @click="$emit('close')" class="btn btn-outline-secondary btn-sm">Cancel</button>
                <button
                    @click="submit"
                    :disabled="saveLoading"
                    class="btn btn-primary btn-sm"
                >{{ saveLoading ? 'Updating...' : 'Update' }}</button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject, ref } from 'vue';
import { useRoute } from 'vue-router';
import handleSdm from '@/services/modules/sdm/sdm';

const props = defineProps({
    month: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      required: true
    },
    contactProfile: {
      type: Object,
      default: null
    },
});

const emit = defineEmits(['close', 'saved']);
const route = useRoute();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const { storeSaleAllocations } = handleSdm();

const amount = ref(props.item.allocation_amount);
const saveLoading = ref(false);

const getQuery = () => {
    let q = `?company_id=${route.params.companyId}`;
    q += `&month=${props.month}`;
    return q;
};

const submit = async () => {
    if (!amount.value && amount.value !== 0) { showError('Allocation Amount is required.'); return; }

    saveLoading.value = true;

    const payload = {
        company_id: route.params.companyId,
        contact_profile_id: props.item.contact_profile_id,
        sales_person_id: props.contactProfile ? props.contactProfile.id : null,
        amount: amount.value,
        status: 'active',
        date: props.month,
        is_create: false,
        is_profile: true
    };

    await storeSaleAllocations(payload, getQuery())
        .then(res => {
            if (!res.status) { showError(res.message); return; }
            showSuccess(res.message);
            emit('saved');
            emit('close');
        })
        .catch(() => { showError('Something went wrong.'); })
        .finally(() => { saveLoading.value = false; });
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
    backdrop-filter: blur(2px);
}

.modal-card {
    background: #fff;
    border-radius: 14px;
    width: 100%;
    max-width: 420px;
    box-shadow: 0 20px 60px rgba(0,0,0,0.2);
    overflow: hidden;
    margin: 1rem;
}

.modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1.25rem;
    background: linear-gradient(90deg, #1e3a5f, #2d6a9f);
}

.modal-title {
    margin: 0;
    font-size: 0.95rem;
    font-weight: 600;
    color: #fff;
    display: flex;
    align-items: center;
    gap: 8px;
}

.modal-close {
    background: none;
    border: none;
    color: #fff;
    cursor: pointer;
    font-size: 1rem;
    opacity: 0.8;
    padding: 0;
    line-height: 1;
    transition: opacity 0.15s;
}

.modal-close:hover { opacity: 1; }

.modal-body {
    padding: 1.25rem;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.modal-footer {
    padding: 0.75rem 1.25rem;
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
    background: #f8fafc;
    border-top: 1px solid #e5e7eb;
}

.info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f1f5f9;
    border-radius: 8px;
    padding: 0.5rem 0.75rem;
    gap: 0.5rem;
}

.info-label {
    font-size: 0.75rem;
    font-weight: 600;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    white-space: nowrap;
}

.info-val {
    font-size: 0.875rem;
    font-weight: 600;
    color: #1e293b;
    text-align: right;
}

.field-label {
    display: block;
    font-size: 0.78rem;
    font-weight: 600;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    margin-bottom: 4px;
}
</style>
